export default __webpack_public_path__ + "src/images/galleries/2/info_cn-95bdb4.png";